import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'
import userAccount from './userAccount/userAccountReducer';

const rootReducer =(history)=> combineReducers({
  router: connectRouter(history),
  userAccount
});

export default rootReducer;
